import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Caption2, SkeletonLoader, ListSeparator, Menu, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { useVariables } from "~/repository/useVariables.js";
import { TextVariablesList } from "./TextVariablesList.js";

const InsertTextVariables = ({ type, handleSelectVariable, handleOpenMenu, handleCloseMenu, variableMenuOpen }) => {
  const { t } = useTranslation();
  const { data: variablesData, isLoading } = useVariables(type, {
    enabled: variableMenuOpen,
    staleTime: 60000,
  });

  return (
    <Menu
      open={variableMenuOpen}
      target={
        <Tooltip title={t("Insert variable")}>
          <Button
            size="medium"
            type="button"
            onClick={handleOpenMenu}
            variant="text gray"
            className="tw-w-8 tw-font-bold tw-text-base tw-px-0"
            active={variableMenuOpen}
          >
            {`{ }`}
          </Button>
        </Tooltip>
      }
      mode="wider"
      position="bottom-end"
      onClose={handleCloseMenu}
    >
      {isLoading ? (
        <>
          <div className="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-px-4 tw-py-2 tw-max-h-[220px]">
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
            <SkeletonLoader className="tw-w-full" />
          </div>
          <ListSeparator className="tw-my-2" />
          <div className="tw-flex tw-h-9 tw-px-4 tw-py-2">
            <SkeletonLoader className="tw-w-full" />
          </div>
        </>
      ) : (
        <>
          <TextVariablesList
            textVariable={variablesData}
            handleSelectVariable={handleSelectVariable}
          />
          <ListSeparator className="tw-my-2" />
          <Caption2
            color="secondary"
            className="tw-px-4 tw-pb-2"
          >
            {t(
              "Numerical variables can be increased or decreased for the value of 1 by pressing the + or - button next to it"
            )}
          </Caption2>
        </>
      )}
    </Menu>
  );
};

export default InsertTextVariables;

InsertTextVariables.propTypes = {
  type: PropTypes.string,
  handleSelectVariable: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  handleCloseMenu: PropTypes.func,
  variableMenuOpen: PropTypes.bool,
};
